import { create } from '@bufbuild/protobuf'
import { useQuery } from '@connectrpc/connect-query'
import type { BiddingBidMarket } from '@ebalance/proto/bffuser/v1/bidding_common_model_pb'
import {
  GlobalAlertService,
  ListUnknownIssuerBidMarketsRequestSchema,
} from '@ebalance/proto/bffuser/v1/global_alert_service_pb'

import {
  SIDE_MENU_DOT_QUERY_OPTIONS,
  freshSideMenuDotData,
} from '~/hooks/sideMenuDotQuery'

/**
 * 発注主体区分が空欄の札 (受渡日が今日以降) がある市場 (AC-SC-043、 #10084)。
 * layout の `SideMenuDotsProvider` が 1 か所で呼ぶ。 取得方針は `sideMenuDotQuery` が持ち、
 * 取得中・取得失敗・オフラインで保留中は空にする。
 */
export function useUnknownIssuerBidMarkets(): {
  markets: readonly BiddingBidMarket[]
} {
  const query = useQuery(
    GlobalAlertService.method.listUnknownIssuerBidMarkets,
    create(ListUnknownIssuerBidMarketsRequestSchema, {}),
    SIDE_MENU_DOT_QUERY_OPTIONS,
  )
  const data = freshSideMenuDotData(query)
  if (data === undefined) return { markets: [] }
  return { markets: data.markets }
}
